import { walkObject as u, getVarName as s, get as v } from "../../private/dist/vanilla-extract-private.esm.mjs";
function b(a, e) {
  var r = {};
  if (typeof e == "object") {
    var c = a;
    u(e, (t, f) => {
      if (t != null) {
        var l = v(c, f);
        r[s(l)] = String(t);
      }
    });
  } else {
    var n = a;
    for (var i in n) {
      var o = n[i];
      o != null && (r[s(i)] = o);
    }
  }
  return Object.defineProperty(r, "toString", {
    value: function() {
      return Object.keys(this).map((t) => "".concat(t, ":").concat(this[t])).join(";");
    },
    writable: !1
  }), r;
}
export {
  b as assignInlineVars
};
//# sourceMappingURL=vanilla-extract-dynamic.esm.mjs.map
